// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"pgUasRYgKTdOMBDUTNak0","BreadTop":"_1qwk-L-8NpT6Q3lyX9_XXF","Seeds1":"_1NoR3Sg7ZkFv26IWaYSeB7","Seeds2":"rJjjNXl8KAgomxzUAsNho","Meat":"_27By3t6afo9AOFbaZHs-BQ","Cheese":"_3Xxg-zMN5HGIkTGGAtS8nI","Lettuce":"_2bS1uqieG86k8QQjyYPgi6","Bacon":"_1FuPvnvGSOPSwWWui0bCVS","Onion":"VgBFnWp14zgzIjx7j1-4D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredients/BurgerIngredient.css
// module id = 122
// module chunks = 0